export const columnDefs = [
  {
    field: 'contractorName',
    headerName: 'Name',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'reportingManager',
    headerName: 'Reporting Manager',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'dateOfJoining',
    headerName: 'DOJ',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'location',
    headerName: 'Location',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'lob',
    headerName: 'LoB',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'rtoDays',
    headerName: 'RTO',
    filterParams: { hideMenu: true },
    sortParams: { enabled: true },
  },
  {
    field: 'daysPresent',
    headerName: 'Days Present',
    filterParams: { hideMenu: true },
    sortParams: { enabled: false },
  },
];

export const icon_fontSize = 1.3;
